<template>
    <div class="scroll-wrapper" ref="scrollContainer">
        <div class="scroll-content" :class="containerClass">
            <div
                v-for="(ad, index) in allAds"
                :key="ad.id"
                class="nav-item d-inline-block mr-2"
                :class="{ 'active-ad': index === activeIndex }"
            >
                <router-link :to="ad.link" target="_blank">
                    <img class="rounded-lg mobile-ad" :src="ad.img" alt="">
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { TicketsIndex } from "../../app/consumer/controllers/tickets.index";

export default {
    name: "AdScroll",
    mixins: [TicketsIndex],
    props: {
        containerClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            staticAds: [
                { id: "book-demo", img: "/images/ads/1.jpg", link: "business/book-demo" },
                { id: "airtime-1", img: "/images/ads/3.jpg", link: "/airtime" },
                { id: "home", img: "/images/ads/2.jpg", link: "/" },
                { id: "zesa", img: "/images/ads/6.jpg", link: "/zesa" },
                { id: "zesa-calculator", img: "/images/ads/7.jpg", link: "/calculators/zesa-calculator" }
            ],
            allAds: [],
            activeIndex: 0,
            scrollInterval: null
        };
    },
    computed: {
        paidEvents() {
            const today = new Date().toISOString().split('T')[0];
            return this.tickets.content.data
                .filter(event => event.event_type === "PAID" && event.event_at >= today)
                .map(event => ({
                    id: `event-${event.id}`,
                    img: event.image,
                    link: `/tickets/buy/${this.encode(event.id)}/${event.name.toLowerCase().replace(/ /g, '-')}`
                }));
        }
    },
    async mounted() {
        await this.getTicketEvents();
        this.allAds = [...this.paidEvents, ...this.staticAds];

        this.startAutoScroll();
    },
    beforeDestroy() {
        clearInterval(this.scrollInterval);
    },
    methods: {
        startAutoScroll() {
            const container = this.$refs.scrollContainer;
            if (!container) return;

            this.scrollInterval = setInterval(() => {
                container.scrollLeft += 1; // Very slow scroll

                // If we reach the end, reset to start
                if (container.scrollLeft + container.clientWidth >= container.scrollWidth - 1) {
                    container.scrollLeft = 0;
                }

                // Update active ad
                const ads = container.querySelectorAll(".nav-item");
                let closestIndex = 0;
                let closestDistance = Infinity;
                ads.forEach((ad, index) => {
                    const rect = ad.getBoundingClientRect();
                    const containerRect = container.getBoundingClientRect();
                    const adCenter = rect.left + rect.width / 2;
                    const containerCenter = containerRect.left + containerRect.width / 2;
                    const distance = Math.abs(adCenter - containerCenter);
                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestIndex = index;
                    }
                });
                this.activeIndex = closestIndex;
            }, 20); // smoother, slower movement
        }
    }
};
</script>

<style scoped>
@media (max-width: 768px) {
    .mobile-ad {
        height: 155px;
        transition: transform 0.5s ease, box-shadow 0.5s ease;
    }
}
@media (min-width: 769px) {
    .scroll-wrapper {
        display: none;
    }
}

.scroll-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    scroll-behavior: auto; /* not 'smooth' because we manually move pixels */
}

.scroll-content {
    display: inline-block;
}

/* Focused (active) ad style */
.active-ad .mobile-ad {
    transform: scale(1.1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.35);
}
</style>
